import { GridSortDirection } from '@mui/x-data-grid-pro';
import jsPDF from "jspdf";
import { TFunction } from 'react-i18next';
import autoTable, { RowInput } from "jspdf-autotable"
import { formatDate } from '../../helpers/dateUtils';
import { formatValue, maybeT, percentageFormat } from '../../helpers/helpers';
import { CustomerCreditItem, DiscountDetails, MiscProductItem, Payment, ProductType, SurchargeItem, TaxRate, TransactionDetails, TransactionSummary } from '../../models/transactions';


export const ROWS_PER_PAGE_MOBILE = 50;

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<T, Key extends keyof T>(
  order: GridSortDirection,
  orderBy: Key
): (a: { [key in Key]?: any }, b: { [key in Key]?: any }) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a as T, b as T, orderBy)
    : (a, b) => -descendingComparator(a as T, b as T, orderBy);
}
